
export const LoadingConst ={
    colorPrimary: '#0f395c',
    colorSecondary:'#f49929'
}    
